var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.bulletClasses]},[(_vm.message.userName)?_c('p',{staticClass:"is-size-7 is-capitalized"},[_vm._v(" "+_vm._s(_vm.message.userName)+" ")]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }